import { Component, Prop } from "vue-property-decorator";
import BaseBlock from "@/blocks/base-block";
import { Gallery } from "@/components/gallery/gallery";
import { ImageResourceDTO } from '../../../model/ImageResourceDTO';
import { Block } from '../../../helpers/components';
import { apartmentGalleryData } from './apartment-gallery.data';

@Block(apartmentGalleryData)
@Component({
	components: {
		Gallery
	}
})
export class ApartmentGalleryBlock extends BaseBlock {
	@Prop() gallery: ImageResourceDTO[][];

	expand: boolean = true;
	isTouchDevice: boolean = this.$store.isTouchDevice;

	//created() {
	//	const mql = window.matchMedia("(pointer: coarse)");

	//	this.expand = !mql.matches
	//	this.isTouchDevice = mql.matches
	//}

	mounted() {
		this.expand = !this.$store.isTouchDevice;
	}
}

export default ApartmentGalleryBlock;
